module.exports = __webpack_public_path__ + "static/media/med_slide3.9a64706c.jpg";